import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bf22735")

_pushScopeId("data-v-3bf22735")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row card-p report-mode-bar" }
const _hoisted_3 = { class: "col-md-6 mb-3" }
const _hoisted_4 = { class: "form-label d-block mb-1" }
const _hoisted_5 = { class: "row card-p show-deleted-order-toggle" }
const _hoisted_6 = { class: "show-deleted-order-toggle-wrapper" }
const _hoisted_7 = { class: "address-detail-dialog-heading" }
const _hoisted_8 = { class: "address-detail-dialog-kicker" }
const _hoisted_9 = { class: "address-detail-dialog-title-text" }
const _hoisted_10 = { class: "address-detail-dialog-inner" }
const _hoisted_11 = {
  key: 0,
  class: "address-group-detail-body"
}
const _hoisted_12 = {
  key: 0,
  class: "text-muted mb-0 py-4 text-center"
}
const _hoisted_13 = { class: "order-detail-card__head" }
const _hoisted_14 = { class: "order-detail-card__meta" }
const _hoisted_15 = {
  key: 1,
  class: "order-detail-card__name order-detail-card__name--muted"
}
const _hoisted_16 = {
  key: 2,
  class: "order-detail-card__oid"
}
const _hoisted_17 = {
  key: 3,
  class: "order-detail-card__date"
}
const _hoisted_18 = {
  key: 0,
  class: "order-detail-card__total"
}
const _hoisted_19 = {
  key: 0,
  class: "order-detail-card__lines"
}
const _hoisted_20 = { class: "table table-sm order-lines-table mb-0" }
const _hoisted_21 = { scope: "col" }
const _hoisted_22 = {
  scope: "col",
  class: "text-end text-nowrap"
}
const _hoisted_23 = {
  scope: "col",
  class: "text-end text-nowrap"
}
const _hoisted_24 = { class: "order-lines-table__product" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "text-end fw-semibold" }
const _hoisted_27 = {
  key: 1,
  class: "order-detail-card__empty text-muted small mb-0"
}
const _hoisted_28 = {
  key: 1,
  class: "address-group-detail-pagination"
}
const _hoisted_29 = { class: "address-group-detail-pagination__count" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "text-break" }
const _hoisted_32 = {
  key: 0,
  class: "order-lines-list mb-0"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_35 = { class: "menu-item-wrapper" }
const _hoisted_36 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-user" })
], -1)
const _hoisted_38 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loader }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("message.SELECT")), 1),
        _createVNode(_component_el_select, {
          modelValue: _ctx.reportMode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.reportMode = $event)),
          class: "w-100",
          onChange: _ctx.onReportModeChange
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportModeOptions, (opt) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: opt.value,
                label: _ctx.$t(opt.labelKey),
                value: opt.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createVNode(_component_AdvanceSearch, {
      filter: true,
      filterOption: _ctx.filterOption,
      status: _ctx.statusList,
      onExportFile: _ctx.exportFile,
      onSearch: _ctx.searchHandler,
      onReloadListing: _ctx.reloadReportListing,
      dateFilter: true
    }, null, 8, ["filterOption", "status", "onExportFile", "onSearch", "onReloadListing"]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("label", null, _toDisplayString(_ctx.$t("message.SHOW_DELETED_ORDERS")) + ":", 1),
        _createVNode(_component_el_switch, {
          modelValue: _ctx.showDelete,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDelete = $event)),
          onChange: _ctx.changeShowDelete
        }, null, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.detailDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailDialogVisible = $event)),
      "destroy-on-close": "",
      "append-to-body": "",
      class: "address-group-detail-dialog",
      "close-on-click-modal": false,
      onClosed: _ctx.onDetailDialogClosed
    }, {
      title: _withId(() => [
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("message.ORDERS")) + " · " + _toDisplayString(_ctx.$t("message.ADDRESS")), 1),
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.detailDialogTitle), 1)
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_InnerLoader, { loading: _ctx.detailLoading }, null, 8, ["loading"]),
          (!_ctx.detailLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                (!_ctx.detailOrders.length)
                  ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("message.NO_DATA_FOUND")), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailOrders, (block, bi) => {
                  return (_openBlock(), _createBlock("div", {
                    key: bi,
                    class: "order-detail-card"
                  }, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        (block?.order?.name)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "#",
                              class: "order-detail-card__name",
                              onClick: _withModifiers(($event: any) => (_ctx.handleOrderView(block?.order)), ["prevent"])
                            }, _toDisplayString(block?.order?.name), 9, ["onClick"]))
                          : (_openBlock(), _createBlock("span", _hoisted_15, "—")),
                        (_ctx.orderIdLabel(block?.order))
                          ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.orderIdLabel(block?.order)), 1))
                          : _createCommentVNode("", true),
                        (block?.order?.created_at)
                          ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(block?.order?.created_at), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (block?.order_grand_total)
                        ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(block?.order_grand_total), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (block?.order_lines?.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                          _createVNode("table", _hoisted_20, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _createVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("message.PRODUCT")), 1),
                                _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("message.QUANTITY")), 1),
                                _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("message.TOTAL")), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(block.order_lines, (ol, li) => {
                                return (_openBlock(), _createBlock("tr", { key: li }, [
                                  _createVNode("td", _hoisted_24, _toDisplayString(ol.product_name), 1),
                                  _createVNode("td", _hoisted_25, _toDisplayString(ol.quantity), 1),
                                  _createVNode("td", _hoisted_26, _toDisplayString(ol.line_total), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(_ctx.$t("message.NO_DATA_FOUND")), 1))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.detailLoading && _ctx.detailPagination.total > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                _createVNode("span", _hoisted_29, _toDisplayString(_ctx.detailPagination.total) + " " + _toDisplayString(_ctx.$t("message.RECORDS")), 1),
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next",
                  "current-page": _ctx.detailPagination.current_page,
                  "page-size": _ctx.detailPagination.per_page,
                  total: _ctx.detailPagination.total,
                  "pager-count": 5,
                  small: "",
                  onCurrentChange: _ctx.onDetailOrdersPageChange
                }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"]),
    _createVNode(_component_Table, {
      loading: _ctx.loader,
      columns: _ctx.columns,
      rows: _ctx.rows,
      pagination: _ctx.pagination,
      padding: 2,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      onSorting: _ctx.searchHandler
    }, {
      "cell-customer_name": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.customer?.user?.name), 1)
      ]),
      "cell-email": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.customer?.user?.email), 1)
      ]),
      "cell-order": _withId(({ row: item }) => [
        (item?.order?.name)
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              class: "text-primary",
              onClick: _withModifiers(($event: any) => (_ctx.handleOrderView(item?.order)), ["prevent"])
            }, _toDisplayString(item?.order?.name), 9, ["onClick"]))
          : (_openBlock(), _createBlock("span", _hoisted_30, "—"))
      ]),
      "cell-order_date": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.order?.created_at), 1)
      ]),
      "cell-delivery_address": _withId(({ row: item }) => [
        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.formatAddress(item?.shipping_address)), 1)
      ]),
      "cell-order_count": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.order_count ?? "—"), 1)
      ]),
      "cell-address_total": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.address_total ?? "—"), 1)
      ]),
      "cell-order_total": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.order_grand_total ?? "—"), 1)
      ]),
      "cell-line_product": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.line?.product_name ?? "—"), 1)
      ]),
      "cell-line_qty": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.line?.quantity ?? "—"), 1)
      ]),
      "cell-line_total": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.line?.line_total ?? "—"), 1)
      ]),
      "cell-order_lines": _withId(({ row: item }) => [
        (item?.order_lines?.length)
          ? (_openBlock(), _createBlock("ul", _hoisted_32, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.order_lines, (ol, i) => {
                return (_openBlock(), _createBlock("li", { key: i }, _toDisplayString(ol.product_name) + " — " + _toDisplayString(_ctx.$t("message.QUANTITY")) + ": " + _toDisplayString(ol.quantity) + " — " + _toDisplayString(ol.line_total), 1))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_33, "—"))
      ]),
      "cell-group_detail": _withId(({ row: item }) => [
        _createVNode("button", {
          type: "button",
          class: "btn btn-sm btn-custom",
          onClick: ($event: any) => (_ctx.openAddressGroupDetail(item))
        }, _toDisplayString(_ctx.$t("message.DETAILS")), 9, ["onClick"])
      ]),
      "cell-actions": _withId(({ row: item }) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, _ctx.keyForRow(item)))
        }, [
          _hoisted_34,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === _ctx.keyForRow(item) }]
          }, [
            _createVNode("div", _hoisted_35, [
              (_ctx.$can('view_customer') && item?.customer)
                ? (_openBlock(), _createBlock("div", _hoisted_36, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleViewCustomer(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_37,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("message.VIEW")), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (item?.order)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleOrderView(item?.order)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_39,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("message.VIEW_ORDER_DETAILS")), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange", "onSorting"])
  ]))
})